export const createIdentifier = (booleanArray) => {
  return parseInt(
    booleanArray.reduce((output, item) => {
      output += item ? '1' : '0';
      return output;
    }, ''),
    2,
  );
};
